import React, { FC, useState } from 'react'

import logo from 'Assets/Images/logo-compulog.svg'
import AuthService from 'Services/UAA'
import * as yup from 'yup'

interface IFormInput {
  emailOrCpf: string
}

const passwordValidation: RegExp =
  '/^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$/' as unknown as RegExp

// const validationSchema = yup.object().shape({
//     CPF: yup.string().required('Obrigatório'),
//     DataNascimento: yup.date().required('Obrigatório'),
//     Senha: yup
//         .string()
//         .required('Obrigátório')
//         .matches(
//             passwordValidation,
//             'Deve conter 8 caracteres, uma maiuscula, uma minuscula, um número e um caractere especial',
//         ),
//     RepetirSenha: yup
//         .string()
//         .required('Obrigátório')
//         .oneOf([yup.ref('Senha'), null], 'As senhas devem ser iguais'),
// });

const ChangePassword: FC = () => {
  const [SuccessRecover, setSuccessRecover] = useState<boolean>(false)

  // const formik = useFormik<IFormInput>({
  //     initialValues: {
  //         emailOrCpf: '',
  //     },
  //     validationSchema: validationSchema,
  //     onSubmit: async (values: IFormInput) => {
  //         let result;

  //         if (values.emailOrCpf.indexOf('@')) {
  //             result = await AuthService.RecoverPasswordInit(
  //                 values.emailOrCpf,
  //                 null,
  //             );
  //         } else {
  //             result = await AuthService.RecoverPasswordInit(
  //                 null,
  //                 values.emailOrCpf,
  //             );
  //         }

  //         if (result) {
  //             setSuccessRecover(true);
  //         } else {
  //             setSuccessRecover(false);
  //         }
  //     },
  // });

  return (
    <>dasd</>
    // <form id='form-criar-senha' noValidate onSubmit={formik.handleSubmit}>
    //   <Grid container>
    //     <Grid  className={classes.form_control}  item xs={12} xl={12}>
    //       <Logo id="form-criar-senha-logo" src={logo} />
    //     </Grid>
    //     <Grid className={classes.form_control}  item xs={12} xl={12}>
    //       <TextField
    //       fullWidth
    //       size="small"
    //       scope='form-criar-senha'
    //       label='CPF'
    //       name='cpf'
    //       className="darkmode"
    //       type='text'
    //       formik={formik}
    //       mask='cpf'
    //       />
    //     </Grid>

    //     <Grid className={classes.form_control}  item xs={12} xl={12}>
    //       <DateTimePickerField
    //       disableFuture
    //       scope='form-criar-senha'
    //       label='Data de nascimento'
    //       name='dataNascimento'
    //       className="darkmode"
    //       formik={formik}
    //       openTo="year"
    //       format="dd/MM/yyyy"
    //       views={["year", "month", "date"]}
    //       value={new Date()}
    //       />
    //     </Grid>

    //     <Grid className={classes.form_control}  item xs={12} xl={12}>
    //       <TextField
    //       fullWidth
    //       size="small"
    //       scope='form-criar-senha'
    //       label='Senha'
    //       name='senha'
    //       className="darkmode"
    //       type='password'
    //       formik={formik}
    //       />
    //     </Grid>

    //     <Grid className={classes.form_control}  item xs={12} xl={12}>
    //       <TextField
    //       fullWidth
    //       size="small"
    //       scope='form-criar-senha'
    //       label='Repetir Senha'
    //       className="darkmode"
    //       name='repetirSenha'
    //       type='password'
    //       formik={formik}
    //       />
    //     </Grid>

    //     <Grid item  xs={4} xl={4}>
    //       <Button
    //       id="form-criar-senha-button"
    //       className={classes.btn_login}
    //       variant='contained'
    //       color='primary'
    //       type='submit'
    //       disabled={formik.isSubmitting}>
    //         Enviar
    //       </Button>
    //     </Grid>
    //     <Grid className={classes.form_control}  item xs={12} xl={12}>
    //       {SuccessRecover ? <Typography>Um email com o link para você criar uma nova senha foi enviado para seu email.</Typography> : ''}
    //     </Grid>

    //     <Grid className={classes.form_control}  item  xs={12} xl={12}>
    //       {formik.isSubmitting && <LinearProgress color='primary' />}
    //     </Grid>
    //   </Grid>
    // </form>
  )
}

export default ChangePassword
